import { Output } from "valibot";

import { BotInfoSchema, ChatDataSchema } from "components/SonicBot/schemas";
import { IntegrationHandler } from "shared/integrations";
import { getIntegrationConfiguration } from "shared/integrations/configs";
import { AppConfiguration, GenerationMode } from "shared/types";

import IntegrationButton from "./IntegrationButton";

type Props = {
  botInfo: Output<typeof BotInfoSchema>;
  chatData: Output<typeof ChatDataSchema>;
  config: AppConfiguration;
  generationMode: GenerationMode;
  onIntegrationClick: (
    integration: IntegrationHandler,
    chatId?: string,
  ) => Promise<void>;
  renderedChatId?: string[];
};

function Integrations(props: Props) {
  const {
    botInfo,
    chatData,
    config,
    generationMode,
    onIntegrationClick,
    renderedChatId,
  } = props;

  const lastChatDataItem = chatData.length && chatData.at(-1);

  const renderIntegrations =
    !generationMode &&
    lastChatDataItem &&
    Array.isArray(lastChatDataItem?.integration) &&
    lastChatDataItem.integration.length;
  // check if the integration is already shown
  const isIdPresentInTheAlreadyRenderArray =
    lastChatDataItem &&
    renderedChatId &&
    lastChatDataItem?.id &&
    renderedChatId?.includes(lastChatDataItem.id);

  if (!renderIntegrations) {
    return null;
  }
  if (isIdPresentInTheAlreadyRenderArray) {
    return null;
  }
  // TODO: lastChatDataItem.integration is always there, add discriminated union
  return (
    <div className="flex flex-col gap-1">
      {lastChatDataItem.integration?.map((integration: any, index: number) => {
        const id = integration.id;
        if (id && renderedChatId?.includes(id)) {
          return null;
        }
        return (
          <IntegrationButton
            key={index.toString()}
            botInfo={botInfo}
            integration={getIntegrationConfiguration({
              type: integration.type,
              data: integration,
            })}
            onIntegrationClick={e => {
              return onIntegrationClick(e, lastChatDataItem.id);
            }}
            config={config}
          />
        );
      })}
    </div>
  );
}

export default Integrations;
